import axios from "axios";
import { toastWarning } from "@/lib/toast";

export const addReview = async (data) => {
  if (!data?.userId) {
    return toastWarning("Please login");
  }

  if (data.rating < 1) {
    return toastWarning("Please give a rating of at least 1");
  }

  try {
    const response = await axios.post(
      "/api/review/add-review",
      {
        reviewData: { ...data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      return { success: true };
    }
  } catch (err) {
    console.log(err);
  }
};

export const addReviewLiked = async (data) => {
  if (!data?.userId) {
    return toastWarning("Please login");
  }

  try {
    const response = await axios.patch(
      "/api/review/likedReview",
      {
        reviewData: { ...data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      return { success: true };
    }
  } catch (err) {
    console.log(err);
  }
};

export const addReviewDisliked = async (data) => {
  if (!data?.userId) {
    return toastWarning("Please login");
  }

  try {
    const response = await axios.patch(
      "/api/review/dislikedReview",
      {
        reviewData: { ...data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      return { success: true };
    }
  } catch (err) {
    console.log(err);
  }
};